module.exports = __webpack_public_path__ + "img/nodata_light_v.ec666320.png";